import React from 'react';
import { useDispatch } from 'react-redux';
import Header from '../../../../../../../components/Stake/header';
import * as cirusStakeActions from '../../../../../../../actions/cirus-stake-actions';
import CirusIcon from '../../../../../../../assets/images/Cirus.svg';
import Information from '../../../../../../../components/Stake/frame/unstake/information';

const UnstakeInformation = () => {
  const dispatch = useDispatch();

  return (
    <>
      <Header
        icon={CirusIcon}
        title={`CIRUS-Unstaking`}
        onClickBack={() => dispatch(cirusStakeActions.unstakeSettings())}
      />
      <Information
        continueClick={() => dispatch(cirusStakeActions.unstakeDetails())}
        unstakeImmediatelyClick={() => dispatch(cirusStakeActions.unstakeImmediatelyDetails())}
      />
    </>
  );
};

export default UnstakeInformation;
